export default {
    'shipping-advises': 'إشعارات الشحن',
    'the-shipping-advice': 'إشعار الشحن؟',
    'add-a-shipping-advice': 'إضافة إشعار شحن',
    'shipping-advise': 'إشعار الشحن',
    
    'item': 'المادة'
}